import { Navigate, useLocation } from "react-router-dom";

/**
 * Duplicate-slash guard (PO POLISH item 4): a link built as base + "/" +
 * "/path" produces "//admin/org-settings", which used to fall through to
 * the 404 page. Collapse repeated slashes and redirect so a malformed link
 * can never 404 a real page again.
 */
export function NormalizePath() {
    const location = useLocation();
    if (location.pathname.includes("//")) {
        const normalized = location.pathname.replace(/\/{2,}/g, "/");
        return <Navigate to={`${normalized}${location.search}${location.hash}`} replace />;
    }
    return null;
}
